import { DateTimeViewer, GetDefaultIndexWithCollect } from "../../components";
import { useGetGlanceCommonInfoQuery, useCollectGlancesHistoryMutation } from "../../features/board/glanceApi";
import { useGlanceRoutes } from "./routes";
import { GlanceHistoryCollector } from "./glanceHistoryCollector";
import { EntityCommonInfoModel } from "../../entities/common";
import { Descriptions } from "antd";

export { useGlanceRoutes };

export default GetDefaultIndexWithCollect({
  title: "نگاه‌ها",
  query: useGetGlanceCommonInfoQuery,
  collectMutation: useCollectGlancesHistoryMutation,
  collector: (collectCallback) => <GlanceHistoryCollector collectCallback={collectCallback} />,
  generalInfoPresentor: (info: EntityCommonInfoModel) =>
    info ? (
      <Descriptions size="small" column={{ xxl: 4, xl: 3, lg: 3, md: 3, sm: 2, xs: 1 }}>
        <Descriptions.Item label="تعداد کل" labelStyle={{ color: "gray" }}>
          {info.totalRecords}
        </Descriptions.Item>
        <Descriptions.Item label="آخرین اطلاعات" labelStyle={{ color: "gray" }}>
          <DateTimeViewer value={info.lastCreateAt} mode="date" />
        </Descriptions.Item>
      </Descriptions>
    ) : null,
});
